/* @ngInject */
function GuestSummaryController ($rootScope, $translate, $state, $stateParams, $q, $timeout, AssetPackService, GuestSummaryService, ApprovalsService, ModalService, UdsModalService, ToastService, SegmentService, Utils) {
  const getRequestFormDialogController = () => import('../../../workflow/dialogs/request-form/request-form-dialog.controller')
  const getRequestDetailsDialogController = () => $q.when(import('../../../workflow/dialogs/request-details/request-details-dialog.controller'))

  const ctrl = this

  ctrl.loading = true
  ctrl.summaryData = {
    dataTitle: null,
    accessExpirationDate: null,
    instructions: null,
    successState: false,
    expiredState: false,
    notFoundState: false
  }
  ctrl.assetPackEnabledDownloadAll = false

  const api = {
    getRequestDetailsDialogController,
    _setTitles,
    _handleError,
    _getBriefingSummaryData,
    _getApprovalSummaryData,
    _getAssetPackSummaryData,
    _downloadAllAssetPack
  }
  this.getApi = () => api

  function _setTitles () {
    const dataTitleKeys = {
      BRIEFING: 'briefing',
      APPROVAL: 'solicitation',
      ASSET_PACK: 'title'
    }
    ctrl.dataTitle = $translate.instant(dataTitleKeys[ctrl.type]).toUpperCase()

    const deadLineTitleKeys = {
      BRIEFING: 'availableUntil',
      APPROVAL: 'approvalFormDialog.approvalDeadline',
      ASSET_PACK: 'availableUntil'
    }
    ctrl.deadlineTitle = $translate.instant(deadLineTitleKeys[ctrl.type]).toUpperCase()
  }

  function _handleError (error) {
    if (error.data?.code === 'EXPIRED') {
      ctrl.summaryData.expiredState = true
    } else if (error.data?.code === 'NOT_FOUND') {
      ctrl.summaryData.notFoundState = true
    } else {
      ToastService.defaultErrorToast()
    }
  }

  function _getBriefingSummaryData () {
    GuestSummaryService.getBriefingSummaryData(ctrl.briefingId).then((data) => {
      ctrl.summaryTitle = $translate.instant('guest.summary.briefingTitle', { userName: data.sharedBy.name })
      ctrl.summaryData.dataTitle = data.briefing.name
      ctrl.summaryData.accessExpirationDate = data.accessExpirationDate
      ctrl.summaryData.instructions = data.instructions
    }).catch(api._handleError).finally(() => {
      ctrl.loading = false
      SegmentService.track('workflow-briefing-shared-open', {
        briefing_id: ctrl.briefingId
      })
    })
  }

  function _getAssetPackSummaryData () {
    if (!ctrl.assetPackId) {
      ctrl.loading = false
      api._handleError({ data: { code: 'NOT_FOUND', message: 'Asset pack not found' } })
      return
    }
    AssetPackService.getAssetPackSummaryData(ctrl.assetPackId)
      .then((data) => {
        ctrl.summaryTitle = $translate.instant('guest.summary.assetPackTitle', { userName: data.sharedBy.name })
        ctrl.summaryData.dataTitle = data.title
        ctrl.summaryData.accessExpirationDate = data.accessExpirationDate
        ctrl.summaryData.instructions = data.instructions

        if (ctrl.type === 'ASSET_PACK_DOWNLOAD_ALL') {
          api._downloadAllAssetPack()
        }
      })
      .catch(api._handleError)
      .finally(() => {
        if (ctrl.type !== 'ASSET_PACK_DOWNLOAD_ALL') {
          ctrl.loading = false
        }
      })
  }

  function _getApprovalSummaryData (approvalId) {
    ApprovalsService.getApproval(approvalId).then((data) => {
      ctrl.taskId = data.task.id
      ctrl.summaryData.dataTitle = data.task.title
      ctrl.summaryData.accessExpirationDate = data.deadline
      ctrl.summaryData.instructions = data.message
      ctrl.summaryTitle = $translate.instant('guest.summary.approvalTitle', { userName: data.creator.name })
    }).catch(api._handleError).finally(() => { ctrl.loading = false })
  }

  function _downloadAllAssetPack () {
    GuestSummaryService.downloadAllAssetFoldersAndAssets(ctrl.assetPackId).then((response) => {
      SegmentService.track('downloaded-file', {
        asset_pack_id: ctrl.assetPackId,
        download_all: true
      })
      ctrl.assetPackDownloadAllSuccess = true
    }).catch(() => {
      ctrl.assetPackDownloadAllError = true
    }).finally(() => {
      $timeout(() => {
        ctrl.loading = false
      })
    })
  }

  ctrl.showSummaryData = () => {
    return !ctrl.summaryData.successState && !ctrl.summaryData.expiredState && !ctrl.summaryData.notFoundState && !ctrl.loading
  }

  ctrl.goToGuestHome = () => {
    switch (ctrl.type) {
      case 'BRIEFING': $state.go('guest.home', { selectedTab: 'requests' })
        break
      case 'ASSET_PACK': $state.go('guest.home', { selectedTab: 'assetPacks' })
        break
      case 'ASSET_PACK_DOWNLOAD_ALL': $state.go('guest.home', { selectedTab: 'assetPacks' }, {
        /**
         * Remove download URL from browser history and prevents
         * the action of returning to the page from triggering a new download.
         */
        location: 'replace',
        reload: true
      })
        break
      default: $state.go('guest.home', {})
        break
    }
  }

  ctrl.goBackToAssetPack = () => {
    if (ctrl.assetPackId) {
      $state.go('assetPack.assetPackSummary', { assetPackId: ctrl.assetPackId }, {
        /**
         * Remove download URL from browser history and prevents
         * the action of returning to the page from triggering a new download.
         */
        location: 'replace',
        reload: true
      })
    }
  }

  ctrl.openBriefing = () => {
    getRequestFormDialogController().then(({ RequestFormDialogController }) => {
      ModalService.showModal({
        templateId: 'requestForm.html',
        templateUrl: '/workflow/dialogs/request-form/request-form-dialog.html?$$REVISION$$',
        controller: RequestFormDialogController,
        destroyable: true,
        observeChanges: true,
        data: {
          requestWithUser: false,
          briefingId: ctrl.briefingId
        }
      }).then(requestCreated => {
        if (requestCreated) {
          ctrl.summaryData.successState = true
        }
      })
    })
  }

  ctrl.openApproval = () => {
    api.getRequestDetailsDialogController().then(({ RequestDetailsDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: RequestDetailsDialogController,
        modalName: 'requestDetailsDialog',
        data: {
          id: ctrl.taskId
        }
      })
      modal.open()
    })
  }

  ctrl.getStateDescriptionText = () => {
    if (ctrl.summaryData.successState) return $translate.instant('guest.successBriefing.description')
    if (ctrl.summaryData.expiredState) return $translate.instant('guest.expiredState.description')
    if (ctrl.summaryData.notFoundState) return $translate.instant('guest.notFoundState.description')
  }

  ctrl.getStateAnimationUrl = () => {
    if (ctrl.summaryData.successState || ctrl.assetPackDownloadAllSuccess) return '/assets/img/guest/animation-success.gif'
    if (ctrl.summaryData.expiredState || ctrl.summaryData.notFoundState || ctrl.assetPackDownloadAllError) return '/assets/img/guest/animation-error.gif'
  }

  ctrl.handleDownloadAll = () => {
    if (!ctrl.assetPackEnabledDownloadAll) return
    $state.go('assetPack.assetPackDownloadAll', { assetPackId: ctrl.assetPackId }, { reload: true })
  }

  ctrl.$onInit = () => {
    AssetPackService.addEnableDownloadAllButtonListener((enable) => {
      ctrl.assetPackEnabledDownloadAll = enable
    })

    if (ctrl.type !== 'ASSET_PACK_DOWNLOAD_ALL') {
      api._setTitles()
    }

    const summaryFetchFunctions = {
      BRIEFING: () => api._getBriefingSummaryData(),
      APPROVAL: () => api._getApprovalSummaryData($stateParams.approvalId),
      ASSET_PACK: () => api._getAssetPackSummaryData(),
      ASSET_PACK_DOWNLOAD_ALL: () => api._getAssetPackSummaryData()
    }
    const fetchSummary = summaryFetchFunctions[ctrl.type]
    if (fetchSummary) fetchSummary()
  }

  ctrl.$onDestroy = () => {
    AssetPackService.clearEnableDownloadAllButtonListener()
  }
}

export { GuestSummaryController }
